"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlansTable = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const SecondaryButton_1 = require("../../atoms/SecondaryButton");
const PlansRow_1 = require("../PlansRow");
const store_1 = require("../../utils/store");
const styled_components_1 = __importStar(require("styled-components"));
function PlansTable({ benefits, licenses, onSelect }) {
    const { t } = (0, i18n_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(Container, { role: "table", "aria-label": t(i18n_1.Strings.store.plansTable), "data-e2e": 'PlansTable_Container', children: [(0, jsx_runtime_1.jsxs)(Header, { role: "row", "data-e2e": 'PlansTable_Header', children: [(0, jsx_runtime_1.jsx)(ColumnFirst, { role: "columnheader", "data-e2e": 'PlansTable_ColumnFirst' }), (0, jsx_runtime_1.jsx)(Columns, { "data-e2e": 'PlansTable_Columns', children: licenses.map((license, index) => {
                            return ((0, jsx_runtime_1.jsx)(Column, { role: "columnheader", "data-e2e": 'PlansTable_Column', children: (0, i18n_1.Localized)((0, store_1.stringsForLicenseType)(license.type).name) }, index));
                        }) })] }), (0, jsx_runtime_1.jsx)("div", { role: "rowgroup", "data-e2e": 'PlansTable_div', children: benefits.map((benefit, index) => ((0, jsx_runtime_1.jsx)(PlansRow_1.StorePlansRow, { benefit: benefit, "data-e2e": 'PlansTable_StorePlansRow' }, index))) }), (0, jsx_runtime_1.jsxs)(Footer, { role: "row", "data-e2e": 'PlansTable_Footer', children: [(0, jsx_runtime_1.jsx)(ColumnFirst, { role: "cell", "data-e2e": 'PlansTable_ColumnFirst' }), (0, jsx_runtime_1.jsx)(Columns, { "data-e2e": 'PlansTable_Columns', children: licenses.map((license, index) => ((0, jsx_runtime_1.jsx)(ColumnBottom, { role: "cell", "data-e2e": 'PlansTable_ColumnBottom', children: license.type === 1 ? ((0, jsx_runtime_1.jsx)(LinkContainer, { "data-e2e": 'PlansTable_LinkContainer', children: (0, jsx_runtime_1.jsx)(StyledLearnMoreLink
                                // @ts-ignore - @todo replace
                                , { 
                                    // @ts-ignore - @todo replace
                                    link: window.INSTITUTIONAL_URL, title: (0, i18n_1.Localized)(i18n_1.Strings.store.learnMore), icon: (0, jsx_runtime_1.jsx)(StyledIcon, { name: ui_1.Icons.New_Window }), "data-e2e": 'PlansTable_StyledLearnMoreLink' }) })) : license.isPurchased ? ((0, jsx_runtime_1.jsx)(Purchased, { "data-e2e": 'PlansTable_Purchased', children: (0, i18n_1.Localized)(i18n_1.Strings.store.purchased) })) : ((0, jsx_runtime_1.jsx)(MoreButton, { onClick: () => onSelect(license), "data-e2e": 'PlansTable_MoreButton', children: (0, i18n_1.Localized)(i18n_1.Strings.store.buyNow) })) }, index))) })] })] }));
}
exports.PlansTable = PlansTable;
const Container = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  flex-shrink: 0;

  box-sizing: border-box;

  width: 100%;
  max-width: ${props => props.theme.maxContentWidth}px;

  margin: 20px auto 0 auto;
  padding: 0 20px;
`;
const Header = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  flex-shrink: 0;

  width: 100%;

  ${ui_1.device.tablet((0, styled_components_1.css) `
    flex-direction: row;

    width: auto;
    height: 60px;
  `)}
`;
const Footer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  flex-shrink: 0;

  width: 100%;

  ${ui_1.device.tablet((0, styled_components_1.css) `
    flex-direction: row;

    width: auto;
    height: 70px;
  `)}
`;
const Column = styled_components_1.default.div `
  display: flex;
  flex-basis: 33.3%;
  align-items: center;
  justify-content: center;

  height: 100%;
  min-height: 50px;

  color: ${props => props.theme.text};

  font-size: 14px;

  ${ui_1.device.tablet((0, styled_components_1.css) `
    font-size: 20px;
  `)}

  background-color: ${props => props.theme.store.columnHighlight};
`;
const ColumnFirst = styled_components_1.default.div `
  display: flex;

  ${ui_1.device.tablet((0, styled_components_1.css) `
    min-width: 300px;
  `)}
`;
const ColumnBottom = (0, styled_components_1.default)(Column) `
  background: none;
`;
const Columns = styled_components_1.default.div `
  display: flex;
  flex-grow: 1;

  min-height: 50px;

  ${ui_1.device.tablet((0, styled_components_1.css) `
    height: 100%;
  `)}
`;
const MoreButton = (0, styled_components_1.default)(SecondaryButton_1.SecondaryButton) `
  width: 70px;

  margin: 10px auto;
  padding: 12px 0;

  &:focus-visible {
    outline: ${({ theme }) => `2px solid ${theme.greenSecondary}`};
    outline-offset: 3px;
  }

  ${ui_1.device.tablet((0, styled_components_1.css) `
    margin: auto;

    width: 140px;
  `)}
`;
const Purchased = styled_components_1.default.div `
  width: 70px;

  margin: 10px auto;
  padding: 12px 0;

  font-size: 14px;

  ${ui_1.device.tablet((0, styled_components_1.css) `
    margin: auto;
  `)}
`;
const LinkContainer = styled_components_1.default.div `
  display: flex;
  justify-content: center;
`;
const StyledLearnMoreLink = (0, styled_components_1.default)(ui_1.LearnMoreLink) `
  margin: auto;
  margin-top: 2px;
  height: 40px;
  width: 140px;
  font-size: 14px;
`;
const StyledIcon = (0, styled_components_1.default)(ui_1.Icon) `
  width: 14px;
  height: 14px;

  margin: auto;

  color: ${props => props.theme.greenSecondary};
`;
